// src/components/ViewCart.js
import React from "react";
import { Box, Link, Typography } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import theme from "../styles/themes/theme";

const ViewCart = () => {
  const pageUrl = "https://www.alphabetsigns.com/cart-contents.html";

  return (
    <Box>
      <Link href={pageUrl} underline="none">
        <ShoppingCartIcon
          sx={{
            color: "#c82027",
            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
          }}
        />{" "}
        <Typography
          sx={{
            display: { xs: "none", sm: "inline-block" },
            fontFamily: "Roboto",
            fontSize: { xs: "0.875rem", sm: "1rem" },
            color: "black",
            fontWeight: 500,
            ml: theme.spacing(0.5),
          }}
        >
          View Cart
        </Typography>
      </Link>
    </Box>
  );
};

export default ViewCart;
